import { useEffect, useRef } from "react";
import { useTour } from "@providers/TourProvider";
import { RecordingWidgetState, useAssetLibraryProvider } from "@/state/providers/AssetLibraryProvider";

/**
 * Bridge component that reads state from AssetLibraryProvider (which wraps TourProvider)
 * and registers it as tour blockers. Must be rendered as a child of both providers.
 */
export default function TourBlockerRegistrations() {
    const { registerTourBlocker, unregisterTourBlocker } = useTour();
    const {
        recordingWidgetControls: { recordingWidgetState },
    } = useAssetLibraryProvider();

    // Use a ref so the blocker callback always reads the latest state without re-registering
    const recordingWidgetStateRef = useRef(recordingWidgetState);
    recordingWidgetStateRef.current = recordingWidgetState;

    useEffect(() => {
        registerTourBlocker("recording", () => {
            const state = recordingWidgetStateRef.current;
            if (state !== RecordingWidgetState.WAITING && state !== RecordingWidgetState.SAVED) {
                return "Please finish your current recording before starting a tour.";
            }
            return null;
        });
        return () => unregisterTourBlocker("recording");
    }, [registerTourBlocker, unregisterTourBlocker]);

    return null;
}
